/**
 * Logger Utility
 * 
 * Production-safe logging that silences debug/info output in production builds.
 * Warnings and errors are always logged (needed for monitoring and debugging production issues).
 * 
 * Usage:
 *   import { logger } from '@/utils/logger';
 *   logger.debug('[MyComponent] loading data:', data);
 *   logger.error('[MyComponent] failed:', error);
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /** Debug-level logging. Silent in production. */
  debug: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },

  /** Info-level logging. Silent in production. */
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },

  /** Warning-level logging. Always logged (production + dev). */
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },

  /** Error-level logging. Always logged (production + dev). */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
